import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../../axios.js';
import {
  GET_PAYMENT_HISTORY_LIST,
  GET_PAYMENT_PROFILES,
  DELETE_PAYMENT_PROFILES,
  ONETIME_PAYMENT,
  GET_AUTO_PAY_STATUS,
  UPDATE_DEFAULT_TOKEN
} from '../../../../Urls.js';

const initialState = {
  payementInfo: {
    email: '',
    firstName: '',
    lastName: '',
    otp1: '',
    otp2: '',
    mobile: ''
  },
  otpSend: { isSend: { email_sent: false, phone_sent: false }, loading: false },
  otpVerification: { loading: false, isVerified: {} },
  paymentIframDetails: { data: '', loading: false },
  activeServices: { data: [], loading: false },
  selectedService: {},
  paymentHistoriesData: { data: [], loading: false },
  paymentProfileData: { data: [], loading: false },
  paymentProfileDataDelete: { data: [], loading: false, successMessage: '' },
  makePaymentAmount: 0,
  getAutoPayStatus: { data: [], loading: false, successMessage: '' },
  triggerPayment: false,
};

export const getPayemntGateWay = createAsyncThunk(
  'app/get/payement/getPayementGateWay',
  async payload => {
    const response = await axios.post(`/api/v1/payment/payment-iframe-link`, payload);
    return response;
  }
);

export const getPaymentHistory = createAsyncThunk(
  'app/get/payement/getPaymentHistory',
  async payload => {
    const response = await axios.post(GET_PAYMENT_HISTORY_LIST, { ...payload });
    return response;
  }
);
export const getAutoPayStatus = createAsyncThunk(
  'app/get/payement/getAutoPayStatus',
  async crm_billing_group_id => {
    const response = await axios.get(GET_AUTO_PAY_STATUS + crm_billing_group_id);
    return response;
  }
);

let lastRequestTime = 0;
let lastRequestPayload = null;

export const makeOnetimePayment = createAsyncThunk(
  'app/get/payement/oneTimePayment',
  async (payload, { rejectWithValue }) => {
    const currentTime = Date.now();

    // Check if the last request was within 1 second and has the same payload
    if (
      lastRequestPayload &&
      JSON.stringify(lastRequestPayload) === JSON.stringify(payload) &&
      currentTime - lastRequestTime < 30000
    ) {
      return rejectWithValue('Duplicate request blocked within 30 second');
    }

    // Update request tracking
    lastRequestTime = currentTime;
    lastRequestPayload = payload;

    try {
      const response = await axios.post(ONETIME_PAYMENT, { ...payload });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Payment failed');
    }
  }
);

export const getPaymentProfiles = createAsyncThunk(
  'app/get/payement/getPaymentProfiles',
  async payload => {
    if (payload.crm_customer_id !== undefined && payload.crm_customer_id !== null) {
      const response = await axios.post(
        `${GET_PAYMENT_PROFILES}${payload.crm_customer_id}&service_account_number=${payload.crm_service_account_id}&billing_account_number=${payload.crm_billing_account_id}&parent_account_number=${payload.parent_account_number}`
      );
      return response;
    }
  }
);

export const updateDefaultToken = createAsyncThunk(
  'app/get/payement/updateDefaultToken',
  async payload => {
    const response = await axios.put(
      `${UPDATE_DEFAULT_TOKEN}${payload.crm_customer_id}&crm_service_account_id=${payload.crm_service_account_id}&crm_billing_group_id=${payload.crm_billing_account_id}&token=${payload.token}`
    );
    return response;
  }
);

export const deletePaymentProfiles = createAsyncThunk(
  'app/get/payement/deletePaymentProfile',
  async payload => {
    const response = await axios.delete(
      `${DELETE_PAYMENT_PROFILES}?crm_customer_id=${payload.crm_customer_id}&token=${payload.token}`,
      {
        data: payload
      }
    );
    return response;
  }
);

export const payementSlice = createSlice({
  name: 'payementSlice/payemnet',
  initialState,
  reducers: {
    resetPaymentData: (state, action) => {
      state.paymentIframDetails = { data: '', loading: false };
    },
    setMakePaymentAmount: (state, action) => {
      state.makePaymentAmount = action.payload;
    },
    setSelectedService: (state, action) => {
      state.selectedService = action.payload;
    },
    setTriggerPayment: (state, action) => {
      state.triggerPayment = action.payload;
    },
    updatedPaymentInfo: (state, action) => {
      const { event, feild } = action?.payload;
      let curentVlaues = { ...state.payementInfo };
      curentVlaues[feild] = event;

      state.payementInfo = { ...curentVlaues };
    },
    clearSuccessMessage: state => {
      state.paymentProfileDataDelete.successMessage = '';
    }
  },

  extraReducers: builder => {
    builder
      .addCase(getPayemntGateWay.pending, state => {
        state.paymentIframDetails.loading = true;
      })
      .addCase(getPayemntGateWay.fulfilled, (state, action) => {
        state.paymentIframDetails.loading = false;
        state.paymentIframDetails.data = action?.payload?.data?.data;
      })
      .addCase(getPayemntGateWay.rejected, state => {
        state.paymentIframDetails.loading = false;
        state.paymentIframDetails.data = [];
      })
      .addCase(getPaymentHistory.pending, state => {
        state.paymentHistoriesData.loading = true;
      })
      .addCase(getPaymentHistory.fulfilled, (state, action) => {
        state.paymentHistoriesData.loading = false;
        state.paymentHistoriesData.data = action?.payload?.data?.data;
      })
      .addCase(getPaymentHistory.rejected, state => {
        state.paymentHistoriesData.loading = false;
        state.paymentHistoriesData.data = [];
      })
      .addCase(getAutoPayStatus.pending, state => {
        state.getAutoPayStatus.loading = true;
      })
      .addCase(getAutoPayStatus.fulfilled, (state, action) => {
        state.getAutoPayStatus.loading = false;
        state.getAutoPayStatus.data = action?.payload?.data?.data;
      })
      .addCase(getAutoPayStatus.rejected, state => {
        state.getAutoPayStatus.loading = false;
      })
      .addCase(getPaymentProfiles.pending, state => {
        state.paymentProfileData.loading = true;
      })
      .addCase(getPaymentProfiles.fulfilled, (state, action) => {
        state.paymentProfileData.loading = false;
        state.paymentProfileData.data = action?.payload?.data?.data;
      })
      .addCase(getPaymentProfiles.rejected, state => {
        state.paymentProfileData.loading = false;
        state.paymentProfileData.data = [];
      })
      .addCase(deletePaymentProfiles.pending, state => {
        state.paymentProfileDataDelete.loading = true;
      })
      .addCase(deletePaymentProfiles.fulfilled, (state, action) => {
        state.paymentProfileDataDelete.loading = false;
        state.paymentProfileDataDelete.data = action?.payload?.data?.data;
        state.paymentProfileDataDelete.successMessage = 'Payment profile deleted successfully!';
      })
      .addCase(deletePaymentProfiles.rejected, state => {
        state.paymentProfileDataDelete.loading = false;
        state.paymentProfileDataDelete.successMessage = 'Failed to delete payment profile.';
      });
  }
});

export const {
  resetPaymentData,
  updatedPaymentInfo,
  setSelectedService,
  clearSuccessMessage,
  setMakePaymentAmount,
  setTriggerPayment
} = payementSlice.actions;

export default payementSlice.reducer;
